import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2Icon, ShieldCheckIcon, DownloadIcon } from 'lucide-react';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="offer" ref={ref} className="w-full py-16 md:py-24 bg-gradient-to-b from-[#2D6A4F] to-[#40916C]" data-id="element-97">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-99">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-100">
            Recupera el control de tu alimentación hoy mismo
          </h2>
          <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto" data-id="element-101">
            Deja de ser un consumidor pasivo y conviértete en productor urbano
            por el precio de dos ensaladas mediocres del supermercado.
          </p>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl mb-8" data-id="element-102">
            <div className="mb-8" data-id="element-103">
              <div className="inline-block bg-[#D8F3DC] px-4 py-2 rounded-full mb-4" data-id="element-104">
                <span className="text-sm font-medium text-[#2D6A4F]" data-id="element-105">
                  Acceso Inmediato
                </span>
              </div>
              <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-106">
                <span className="text-2xl md:text-3xl text-gray-400 line-through" data-id="element-107">
                  $17,99
                </span>
                <span className="text-5xl md:text-6xl font-bold text-[#2D6A4F]" data-id="element-108">
                  $6,39
                </span>
                <span className="text-xl text-gray-600" data-id="element-109">USD</span>
              </div>
              <p className="text-gray-600" data-id="element-110">Pago único • Sin suscripciones</p>
            </div>

            <div className="space-y-3 mb-8 text-left max-w-md mx-auto" data-id="element-111">
              {['Guía completa en PDF', 'Acceso instantáneo', 'Actualizaciones gratuitas', 'Garantía de satisfacción'].map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-112">
                  <CheckCircle2Icon className="w-5 h-5 text-[#40916C] flex-shrink-0" data-id="element-113" />
                  <span className="text-gray-700" data-id="element-114">{item}</span>
                </div>)}
            </div>

            <a href="https://www.nachogerberg.com/cart/42672813834311:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-115">
              <Button size="lg" className="w-full bg-[#2D6A4F] hover:bg-[#40916C] text-white text-xl px-8 py-6 rounded-full shadow-lg hover:shadow-xl transition-all mb-4" data-id="element-116">
                ¡QUIERO MI COSECHA EN 30 DÍAS!
              </Button>
            </a>

            <div className="flex items-center justify-center gap-6 text-sm text-gray-600" data-id="element-117">
              <div className="flex items-center gap-2" data-id="element-118">
                <ShieldCheckIcon className="w-4 h-4" data-id="element-119" />
                <span data-id="element-120">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-121">
                <DownloadIcon className="w-4 h-4" data-id="element-122" />
                <span data-id="element-123">Descarga instantánea</span>
              </div>
            </div>
          </div>

          <p className="text-white/80 text-sm" data-id="element-124">
            Comienza tu transformación hoy. Tu balcón te está esperando.
          </p>
        </motion.div>
      </div>
    </section>;
}